import React,{useState} from "react";
import { Box, Button } from "@mui/material";
import DynamicTableForJson from "../../../../../data/DynamicTable/dynamicTableForJson";
import { customerservice } from "../../../../../config";
import GuarantorForm from "./form";
import { useNavigate } from "react-router-dom";
import UploadStatementForm from "./form";
import Joyride from "react-joyride"; //Import Joyride

const base_url = customerservice.uri;
// Define tour steps for the Rights page
const rightsTourSteps = [
  {
    target: ".dynamic-table-header",
    content: "This is the Mpesa Statements page, where you can view a Customer's Mpesa Statements.",
    placement: "top",
    disableBeacon: true,
  },
  {
    target: ".dynamic-table-search",
    content: "Use the search bar to find a specific statement by name or other criteria.",
    placement: "bottom",
  },
  {
    target: ".dynamic-table-add-button",
    content: "Click this button to upload mpesa statement.",
    placement: "right",
  },
  // {
  //   target: ".dynamic-table-grid",
  //   content: "This table displays all rights. You can view and manage them here.",
  //   placement: "top",
  // },
  // {
  //   target: ".dynamic-table-actions",
  //   content: "Select actions like Edit or Deactivate for each collateral detail from this dropdown.",
  //   placement: "left",
  // },
];
const MpesaStatemets = () => {
  const [runTour, setRunTour] = useState(false); // ▶️ State to control Joyride

  const customerId = localStorage.getItem("CustomerId");
  const decodedToken = JSON.parse(localStorage.getItem("decodedToken"));
  const userId = parseInt(decodedToken.Id);
  const navigate = useNavigate();

  const actions = {
    entity: "Mpesa Statements",
    isSubright: true,
    add: {
      key: "ADD",
      button_name: "Upload Statement",
      Show_Button: true,
      permission: "CreatePermission",
    },
    dataObject: {
      objectName: "customerStatementsById",
      parameters: { customerId: parseInt(customerId) },
      inputObjectName: "statements",
    },
    ViewStatementReport: {
      button_name: "View Report",
      Show_Button: true,
      permission: "hasNoPermission",
      roleGroupId: [1, 2, 3, 4, 5],
    },

    showStatus: true,
  };

  return (
    <Box m="20px">
       <Joyride
              steps={rightsTourSteps}
              run={runTour}
              continuous
              showSkipButton
              showProgress
              styles={{
                options: {
                  primaryColor: "#1976d2",
                  zIndex: 10000,
                },
              }}
            />
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <Button onClick={() => navigate(-1)} variant="contained">
          Back to Customers
        </Button>
        <Button onClick={() => setRunTour(true)} variant="outlined" color="primary">
          Start Page Tour
        </Button>
      </Box>
      <></>
      <DynamicTableForJson
        title="Statements"
        subtitle="Manage Statements"
        FormComponent={UploadStatementForm}
        base_url={base_url}
        actions={actions}
        tourSteps={rightsTourSteps} // Pass tour steps as prop
      />
    </Box>
  );
};

export default MpesaStatemets;
